module.exports = {
  config: {
    h5tgadoc: "/zh/cp/guide/api.html"
  },
  router: {
    index: "首页",
    GameManagement: "游戏管理",
    operation: "运营数据",
    adincome: "广告收入",
    adorder: "订单查看",
    income: "广告营收",
    adresult: "结算管理",
    overview: "数据总览",
    overviewNew: "数据总览(新)",
    retained: "留存分析",
    retainedNew: "留存分析(新)",
    game_analyse: "游戏分析",
    game_analyseNew: "游戏分析(新)",
    AccountManagement: "账号管理",
    Info: "基本信息",
    identity: "身份认证",
    ChangePassword: "修改密码",
    DeveloperDocument: "开发者文档",
    contact: "联系我们",
    GameDetails: "游戏详情",
    GameInfo: "游戏信息",
    GameMaterial: "游戏素材",
    login: "登录",
    register: "注册",
    ForgetPassword: "忘记密码",
    agreement: "协议",
    rank: "排行榜设置",
    basicSettings: "基本设置",
    pay: "支付设置",
    share: "分享设置",
    ad: "广告设置",
    Exploit_settings: "开发设置",
    type: "账号类型",
    appManagement: "应用管理",
    appMaterial: "应用列表"
  },
  index: {
    banner: {
      title: "TGA开发者平台",
      content1: "顶尖互联网产品和渠道的优质流量接入",
      content2: "让游戏分发和变现更加轻松"
    },
    fanctions: {
      name: "业务介绍",
      title: "连接游戏开发者与流量方",
      content:
        "助力内容接入全球市场，帮助开发者与流量方快速实现商业 变现同时，增强流量方自身的趣味性。"
    },
    advantages: {
      name: "优势介绍",
      title: "成熟的变现服务",
      content1: "整合多个广告渠道，利用丰富的广告资源，助力快速商业变现",
      content2: "多维度数据后台，实时查看收益 "
    },
    sdk: {
      name: "便捷的SDK功能",
      advertising: {
        content1: "广告SDK",
        content2: "助力变现"
      },
      leaderboard: {
        content1: "排行SDK",
        content2: "丰富玩法"
      },
      singlen: {
        content1: "账号SDK",
        content2: "便捷打通平台与游戏"
      },
      button: "了解更多"
    },
    global: {
      name: "全球化的合作伙伴",
      title: "广阔的流量渠道和丰富的游戏资源",
      content1: "与多家流量方达成合作，拥有广阔的平台资源",
      content2: "丰富的游戏资源，为流量平台的用户注入更多的活力 "
    },
    join: {
      title1: "即刻加入 TGA 开发者平台，",
      title2: "让更多人看到你的游戏",
      button: "合作咨询"
    }
  },
  contact: {
    about: {
      title: "ABOUT TGA",
      content:
        "我们为游戏而生。我们寻找对游戏行业充满热情的有志之士加入我们，跟我们一起成长。"
    },
    careers: {
      name: "履历",
      title1: "开发&运营",
      title2: "渠道建设",
      title3: "商业开发",
      title4: "平台建设",
      title5: "游戏",
      text1: [
        "10年以上相关工作经验",
        "成功案例是否涵盖PC、手机和平台",
        "拥有多家稳定的手机游戏和H5制作工作室及10000多家密切合作伙伴",
        "拥有自主开发的人工智能，对超过40万个角色进行个性化推荐"
      ],
      text2: [
        "独创91产品团队，10年协调经验",
        "13年海外游戏平台运营经验",
        "10年中东地区工作经验",
        "平台运营用户超过2亿"
      ],
      text3: [
        "10年游戏行业从业经验",
        "中国手游发展的领导者",
        "被认为是中国数百家上市公司的孵化器",
        "与中国80%的游戏公司董事长直接接触"
      ],
      text4: [
        "MMOsite.com(2005-2009)曾是全球排名前三的MMORPG门户网站，2008年被ND收购",
        "91移动2亿活跃用户，日交易量1.5亿，以19亿美元现金出售给百度",
        "Mobomarket, Macrobile,1亿海外用户，50%的周活跃度",
        "中东游戏平台Wakit已获得2200万活跃用户",
        "拥有600万用户的伊朗游戏公司Bazik覆盖了3/4的伊朗手机用户",
        "get5100万印度用户，卖给了telkomsel",
        "VR平台运营与设计",
        "负责产品设计与集成"
      ],
      text5: [
        "建立的产品涵盖MMORP, SLG, ARPG, MOBA类y",
        "RPG, 300万DAU, 800万美元的月营业额",
        "APRG, 500万人民币，月营业额1000万美元",
        "MOBA游戏:PC端450万DAU，手机端100万DAU，月营业额1000万"
      ]
    },
    contact: {
      name: "联系我们",
      company: "JUST4FUN PTE.LTD. ",
      place: "2 Havelock Road #06-01 Havelock2 Singapore 059763",
      email: "business_global@just4fun.sg",
      form: {
        first: "姓",
        last: "名",
        email: "邮箱",
        company: "公司",
        remark: "备注",
        submit: "提交"
      },
      info: "请完善信息",
      emailInfo: "请输入正确的邮箱地址",
      success: "提交成功",
      error: "提交失败"
    }
  },
  login: {
    to_login: "账号登录",
    login: "登录",
    no_id: "还没有账号?",
    to_register: "前往注册",
    no_psd: "忘记密码?",
    email: "邮箱",
    email_error: "邮箱格式不正确",
    psd: "密码",
    empty_psd: "密码不能为空",
    sum_length: "字母、数字或者英文符号,长度8~15位",
    empty_email: "邮箱不能为空"
  },
  register: {
    registeraccount: "注册账号",
    getcode: "获取验证码",
    registertext: "注册",
    emailsite: "邮箱地址",
    email_error: "邮箱格式不正确",
    text: "请输入未注册过本平台账号的邮箱",
    code: "验证码",
    codekong: "验证码不能为空",
    codetext: "激活邮箱后将收到验证邮件，请回填邮件中的6位验证码",
    psd: "密码",
    empty_psd: "密码不能为空",
    psd_init: "字母、数字或者英文符号，长度8~15位，区分大小写",
    psd1: "确认密码",
    no_psd1: "密码不一致",
    emailkong: "邮箱不能为空",
    code_error: "验证码格式错误",
    anewgetcode: "重新获取",
    codesuccess: "获取成功"
  },
  account_type: {
    totype: "选择账号类型",
    game: "游戏开发者",
    cptext: "我有游戏资源，我想上架TGA",
    app: "渠道合作方",
    apptext: "我有渠道资源，我要变现",
    confirm: "确定"
  },
  agreement: {
    tgaagreement: "TGA开发者平台签订协议",
    agreementtext:
      "鉴于您作为个人，为其开发之系列游戏软件的著作权人或者合法授权人，以下简称甲方；福州酷乐文化传媒有限公司是一家游戏平台商，以下简称乙方，通过原创游戏平台以展示甲方之游戏；甲方可在乙方的原创游戏平台免费发布游戏，甲方提供推广乙方平台的服务，双方对上述合作事宜，根据《中华人民共和国合同法》、《中华人民共和国著作权法》、《计算机软件保护条例》等相关法律法规之规定，当甲方点击页面的同意（若您未满18周岁，请在监护人的同意下进行本操作）即表示甲方与乙方签订本合作协议。特别提示：若您曾与福州酷乐文化传媒有限公司因游戏推广合作签订过任何协议如原创游戏广告分成合作协议，自本协议生效后，原先签订的协议自动终止，本协议生效以前所有未结算的款项，均以本合作协议约定的为准。本合作协议只适用于您作为个人的情形，若您为公司或其他组织，需与乙方签订纸质版的相关合作协议。具体条款如下：",
    agreeagreement: "同意并遵守以上协议",
    next: "下一步",
    nonext: "请同意协议",
    error: "服务器繁忙"
  },
  footer: {
    text: " Copyright © 2012-2020 Tencent. All Rights Reserved.",
    to_login: "请先登录账号",
    to_info: "请先填写基本信息"
  },
  forget: {
    no_psd: "忘记密码",
    next: "下一步",
    emailsite: "邮箱地址",
    getcode: "获取验证码",
    last: "上一步",
    confirm: "确定",
    email_error: "邮箱格式不正确",
    getemail: "请输入要找回密码的邮箱地址",
    code: "验证码",
    no_code: "验证码不能为空",
    psd: "密码",
    emptypsd: "密码不能为空",
    psd1: "确认密码",
    nopsd1: "密码不一致",
    regain: "重新获取",
    getsuccess: "获取成功",
    code_error: "验证码发送失败",
    code_error2: "验证码请求过于频繁",
    code_error3: "验证码今日发送次数已达上限",
    successfully: "修改成功"
  },
  account_management: {
    Change_Password: {
      ChangePassword: "修改密码",
      alter: "修改",
      originalpsd: "原密码",
      please_originalpsd: "请输入原密码",
      psd: "密码",
      empty_psd: "密码不能为空",
      psd_init: "字母、数字或者英文符号，长度8~15位，区分大小写",
      psd1: "确认密码",
      no_psd1: "密码不一致",
      empty_originalpsd: "原密码不能空",
      successfully: "修改成功"
    },
    authentication: {
      text: "您还未提交身份认证审核，暂时无法提交游戏审核。",
      text1: "您已提交身份认证审核，请耐心等待审核结果。",
      text2: "您已通过身份认证审核。",
      text3: "您未通过身份认证审核。",
      developer: "开发者",
      progress: "认证进度",
      type: "开发者类型",
      individual_person: "个人",
      company: "企业",
      email: "如需修改此项，请联系客服邮箱",
      copy: "点击复制",
      account: "开户名",
      please_account: "请填写开户名",
      account_kong: "开户名不能为空",
      id: "身份证号码",
      please_id: "请填写身份证号码",
      id_kong: "身份证号码不能空",
      idNo: "统一社会信用代码",
      please_idNo: "请填写统一社会信用代码",
      idNo_kong: "社会信用代码不能为空",
      idtext: "身份证正反面",
      idNotext: "企业营业执照扫描件",
      sample: "示例图",
      uploadid: "请上传身份证正反面",
      uploadidNo: "请上传企业营业执照扫描件",
      uploadidtext: "请上传jpg格式文件，不超过2M，身份证正反面合成一张上传",
      uploadidNotext: "请上传jpg格式文件，不超过2M，",
      country: "国家",
      please_country: "请选择国家",
      bank: "银行名称",
      select: "请选择",
      please_bank: "请选择银行",
      province: "支行省市",
      please_province: "请选择支行省市",
      bankName: "银行名称",
      please_bankName: "请填写银行名称",
      bankName_kong: "银行名称不能为空",
      bankAccount: "银行账号",
      please_bankAccount: "请填写银行账号",
      groupType: "发票类型",
      please_groupType: "请选择发票类型",
      send_review: "提交审核",
      audit: "审核中",
      isaudit: "是否确定提交审核",
      ok: "确认",
      cancel: "取消",
      sendsuccess: "提交成功",
      upimgerror: "上传头像图片只能是 JPG 格式!",
      upimgerror2: "上传头像图片大小不能超过 2MB!",
      upsuccess: "上传成功",
      uperror: "上传失败",
      copysuccess: "复制成功",
      uploadimg: require("@/img/img.png"),
      code: "Swift Code不能为空",
      code_please: "请填写Swift Code",
      bank_site: "银行地址",
      bank_kong: "银行地址不能为空",
      address: "请填写银行地址",
      currency_type: "货币类型",
      type_kong: "货币类型不能为空",
      swift_code: "Swift Code"
    },
    information: {
      developer: "开发者",
      progress: "认证进度",
      type: "开发者类型",
      individual_person: "个人",
      company: "企业",
      email: "如需修改此项，请联系客服邮箱",
      copy: "点击复制",
      name: "名字",
      surname: "姓氏",
      empty_name: "姓名不能为空",
      enterprise: "企业名称",
      empty_enterprise: "请填写企业名称",
      location: "所在地",
      select: "请选择",
      select_location: "请选择所在地",
      site: "联系地址",
      select_site: "请填写地址",
      phone: "手机号码",
      alter: "修改",
      select_phone: "请填写手机号",
      save: "保存",
      save_success: "保存成功",
      copysuccess: "复制成功"
    }
  },
  info: {
    basicinfo: "基本信息",
    type: "开发者类型",
    individual_person: "个人",
    company: "企业",
    name: "名字",
    surname: "姓氏",
    empty_name: "姓名不能为空",
    enterprise: "企业名称",
    empty_enterprise: "请填写企业名称",
    location: "所在地",
    select: "请选择",
    select_location: "请选择所在地",
    site: "联系地址",
    select_site: "请填写地址",
    phone: "手机号码",
    select_phone: "请填写手机号",
    empty_phone: "手机号码不能为空",
    next: "下一步",
    error: "服务器繁忙"
  },
  layout: {
    select_login: "请先登录账号",
    select_info: "请先填写基本信息",
    logo: require("@/img/logo_cn.png"),
    logo2: require("@/img/logo_cn2.png")
  },
  nav_user: {
    login: "登录",
    register: "注册",
    logout: "退出",
    languagezh: "简体中文",
    languageen: "English",
    langtext: "简体中文"
  },
  operational_data: {
    app: "APP",
    game: "游戏",
    select: "请选择",
    select_name: "请输入订单号",
    select_id: "请输入ID",
    order: "订单号",
    userId: "用户的ID",
    data: "导出数据",
    selecttime: "选择时间",
    orderstate: "订单状态",
    send: "查询",
    no_result: "暂无数据",
    orderstatus: ["全部", "支付中", "支付成功", "支付失败"],
    createTime: "日期",
    wareName: "购买商品",
    wareCnt: "商品数量",
    price: "支付金额",
    user: "用户",
    state: "订单状态",
    pay1: "支付中",
    pay2: "支付成功",
    pay3: "支付失败",
    kong: "无",
    income: {
      day: "日期",
      income: "流水",
      incomeCount: "总流水",
      estimatedRevenue: "估算收益",
      estimatedRevenueCount: "估算总收益",
      createTime: "创建时间",
      oneMonths: "上个月",
      threeMonths: "上三个月",
      sixMonths: "上六个月",
      tip: "注：",
      tipFirst: "1.预估收益未扣除银行手续费和相关税费, 相应费用每月不同。 ",
      tipSecond: "2.预估收益为参考收益，不作为实际结算依据。",
      tipThird: "3.本月收益在下个月20号左右结算，请联系平台商务人员。"
    },
    overview: {
      app: "APP",
      select: "请选择",
      platform: "平台",
      dateRange: "选择时间",
      Apply: "查询",
      dataOverview: "数据总览",
      cumulativeUsersTitle: "累计用户",
      yesterdayDAU: "昨日活跃用户",
      yesternewUsers: "昨日新增",
      yestergameUsers: "昨日游戏人数",
      yestergameTimes: "昨日游戏次数",
      activeTrend: "活跃趋势 ",
      cumulativeUsers: "累计用户数",
      DAU: "活跃用户",
      newUsers: "新增用户",
      gameUsers: "游戏用户",
      gameTimes: "人均游戏次数",
      exportData: "下载数据",
      date: "日期",
      newUsersRate: "新增占比",
      averageGameLaunchTimes: "人均游戏次数"
    },
    retained: {
      app: "APP",
      select: "请选择",
      platform: "平台",
      dateRange: "选择时间",
      Apply: "查询",
      retentionAnalysis: "留存分析",
      newUsersRetention: "新增用户留存",
      retainedUsersRetention: "既有用户留存",
      day: "日",
      week: "周",
      exportData: "下载数据",
      date: "日期",
      users: "用户数",
      day2Users: "次留",
      day2retentionRate: "次留率",
      day3Users: "三留",
      day3retentionRate: "三留率",
      day7Users: "七留",
      day7retentionRate: "七留率",
      day15Users: "十五留",
      day15retentionRate: "十五留率",
      day30Users: "三十留",
      day30retentionRate: "三十留率",
      startDate: "开始日期",
      endDate: "截止日期",
      week2Users: "次周",
      week2RetentionRate: "次周留存率",
      week3Users: "三周",
      week3RetentionRate: "三周留存率",
      week4Users: "四周",
      week4RetentionRate: "四周留存率"
    },
    game_analyse: {
      app: "APP",
      select: "请选择",
      platform: "平台",
      gameName: "游戏名",
      dateRange: "选择时间",
      Apply: "查询",
      gameAnalysis: "游戏分析",
      gameUsers: "游戏用户",
      averageGameLaunchTimes: "人均游戏次数",
      exportData: "下载数据",
      date: "日期",
      gameLaunchTimes: "游戏次数"
    }
  },

  gamelist: {
    state: "审核状态",
    addgame: "新建游戏",
    addApp: "新建应用",
    gamename: "请输入游戏名称",
    appname: "请输入应用名称",
    began: "开始去",
    create: "创建",
    creategame: " 你的第一款游戏吧！",
    createapp: "你的第一款APP吧！",
    admi: "管理",
    down: "下架",
    up: "上架",
    delete: "删除",
    isDelete: "是否确定删除",
    arrSelect: [
      "全部状态",
      "未提审",
      "审核中",
      "审核通过",
      "审核失败",
      "已上线"
    ],
    appId: "应用ID",
    gameId: "游戏ID",
    appnames: "APP名称",
    appName: "游戏名称",
    version: "线上版本",
    checkState: "审核状态",
    kong: "无",
    allstate: ["未提审", "审核中", "审核通过", "审核失败", "已上线"],
    lastModified: "更新时间",
    btn: "操作",
    upSuccess: "上架成功",
    downSuccess: "下架成功",
    isup: "是否确定上架",
    isdown: "是否确定下架",
    ok: "确认",
    cancel: "取消"
  },

  foundgame: {
    creategame: "创建游戏",
    complete: "完善游戏信息",
    send: "提交审核",
    publish: "发布上线",
    info: "基本信息",
    gameType: "游戏类型",
    aloneGame: "单机游戏",
    battleGame: "对战游戏",
    battleSum: "对战人数",
    radio: "屏幕方向",
    mobile: "是否支持手机端",
    horizontalOnly: "是否只支持横屏",
    yes: "是",
    no: "否",
    across: "横屏",
    vertical: "竖屏",
    tag: {
      title: "游戏标签",
      add: "添加",
      tip: "用于小游戏搜索和推荐识别，一旦发布上线，无法修改，请谨慎选择。",
      confirm: "确定"
    },
    lang: "支持语言",
    langkong: "语言不能为空",
    gamename: "游戏名称",
    gameinfo: "游戏介绍",
    agreement: "我已经阅读并接受",
    agreement1: "《TGA开发者平台与开发者协议》",
    english: "英语",
    chinese: "中文",
    Turkey: "土耳其"
  },
  foundapp: {
    tip: "注:",
    tipFirst: "正式包的包名请放第一个",
    createapp: "创建应用",
    complete: "完善应用信息",
    send: "提交审核",
    info: "基本信息",
    apptype: "应用类型",
    android: "安卓",
    ios: "苹果",
    web: "WEB",
    allApp: "全部",
    androidtext: "如有多个包名，请用英文逗号隔开",
    lang: "默认语言",
    langkong: "语言不能为空",
    gametype: "可接受游戏类型",
    across: "横屏",
    vertical: "竖屏",
    all: "两种均可",
    appname: "应用名称",
    agreement: "我已经阅读并接受",
    agreement1: "《TGA开发者平台与开发者协议》",
    english: "英语",
    chinese: "中文",
    Turkey: "土耳其",
    packageName: "包名",
    description: "备注",
  },

  appinfo: {
    createapp: "创建应用",
    complete: "完善应用信息",
    send: "提交审核",
    createtime: "创建时间",
    appstate: "应用状态",
    state: ["开发中", "审核中", "审核通过", "审核失败", "开发中", "已上线"],
    share: {
      on: "开",
      off: "关",
      sharing: "第三方分享",
      appID: "app ID",
      sharesetting: "分享设置"
    },
    ad: {
      on: "开",
      off: "关",
      ads: "第三方广告",
      appID: "app ID",
      adsetting: "广告设置"
    },
    pay: {
      paysetting: "支付设置",
      paytoken: "支付密钥",
      copy: "点击复制",
      dataTokeninfo: "密钥是敏感信息，请不要泄露",
      url: "回调地址",
      save: "保存",
      urlkong: "回调地址不能为空",
      save_success: "保存成功",
      copysuccess: "复制成功"
    },

    exploit: {
      setting: "基本设置",
      sdk: "SDKAppID",
      status: "状态",
      datatoken: "密钥",
      copy: "点击复制",
      dataTokeninfo: "密钥是敏感信息，请不要泄露",
      sdkinfo: "SDK资源",
      text: "请点击查看",
      text1: "《SDK对接指南》",
      email: "如有疑问请联系客服Email",
      state: ["开发中", "审核中", "审核通过", "审核失败", "开发中", "已上线"],
      copysuccess: "复制成功"
    },

    basic: {
      basicinfo: "基本信息",
      apptype: "应用类型",
      android: "安卓",
      androidtext: "如有多个包名，请用英文逗号隔开",
      lang: "默认语言",
      langkong: "语言不能为空",
      gametype: "可接受游戏类型",
      across: "横屏",
      vertical: "竖屏",
      all: "两种均可",
      appname: "应用名称",
      send: "提交",
      english: "英语",
      chinese: "中文",
      success: "提交成功",
      error: "提交失败",
      packageName: "包名"
    },

    material: {
      app_material: "审核素材",
      logo: "LOGO",
      format: "格式仅限jpg,jpeg,gif,png ",
      size: "尺寸：256x256 ",
      size2: "大小：不超过50K",
      apppackage: "应用安装包",
      apk: "仅支持APK",
      time: "最近修改时间",
      no: "暂无",
      send_review: "提交审核",
      cancel_review: "取消审核",
      text: "您还需要",
      identity: "通过身份认证",
      text2: "才能提交审核",
      emailtext:
        "您已提交审核，请耐心等待审核结果。审核结果将通过邮件告知您。如有疑问请联系客服Email",
      copy: "点击复制",
      cancelsuccess: "取消成功",
      logopackage: "请上传LOGO或应用包",
      onthecrossinfo: "上传中请耐心等待",
      sendsuccess: "提交成功",
      onthecrosapk: "只能上传为APK",
      onthecrossimg: "上传LOGO只能是图片",
      onthecrosslogo: "上传LOGO图片大小不能超过 30k!",
      copysuccess: "复制成功",
      apppackageurl: "应用包链接",
      appservice:
        "安装包下载地址：请填写正确的安装包下载地址，用于分享页面的下载地址及应用审核。",
      uploadimg: require("@/img/img.png"),
      addApp: "添加应用",
      updateApp: "修改应用",

    }
  },

  gameinfo: {
    creategame: "创建游戏",
    complete: "完善游戏信息",
    send: "提交审核",
    publish: "发布上线",
    createtime: "创建时间",
    gamestate: "游戏状态",
    state: ["开发中", "审核中", "审核通过", "审核失败", "已上线"],
    pay: {
      paysetting: "支付设置",
      paytoken: "支付密钥",
      copy: "点击复制",
      dataTokeninfo: "密钥是敏感信息，请不要泄露",
      url: "回调地址",
      save: "保存",
      urlkong: "回调地址不能为空",
      save_success: "保存成功",
      copysuccess: "复制成功"
    },

    exploit: {
      setting: "基本设置",
      sdk: "SDKAppID",
      status: "状态",
      datatoken: "密钥",
      copy: "点击复制",
      dataTokeninfo: "密钥是敏感信息，请不要泄露",
      sdkinfo: "SDK资源",
      text: "请点击查看",
      text1: "《SDK对接指南》",
      email: "如有疑问请联系客服Email",
      state: ["开发中", "审核中", "审核通过", "审核失败", "开发中", "已上线"],
      copysuccess: "复制成功"
    },

    basic: {
      gamebasicinfo: "游戏基本信息",
      gameType: "游戏类型",
      aloneGame: "单机游戏",
      battleGame: "对战游戏",
      battleSum: "对战人数",
      radio: "屏幕方向",
      across: "横屏",
      vertical: "竖屏",
      lang: "支持语言",
      langkong: "语言不能为空",
      gamename: "游戏名称",
      gameinfo: "游戏介绍",
      send: "提交",
      english: "英语",
      chinese: "中文",
      Turkey: "土耳其",
      success: "提交成功",
      error: "提交失败"
    },

    material: {
      tip: "注：",
      tipFirst: "1.自己的游戏服务器，游戏内部广告，内购等全部是自己的。",
      game_material: "游戏素材",
      gamelogo: "游戏LOGO",
      format: "格式仅限jpg,jpeg,gif,png ",
      size: "尺寸：256x256 ",
      size2: "大小：不超过50K",
      width: "游戏宽度",
      height: "游戏高度",
      type: "游戏类型",
      sdk: "对接平台SDK",
      other: "独立游戏",
      cooperation: "合作方式",
      myservers: "使用自己的服务器",
      platformservers: "使用平台服务器",
      indieGame: "独立游戏",
      url: "URL地址",
      gameurl: "请输入游戏地址",
      gamemainfile: "游戏主文件",
      gamepreview: "游戏预览",
      onthecross: "上传中",
      text:
        "HTML5游戏请压缩为zip文件后上传。入口文件需命名为index.html,且该文件位于根目录下。",
      text1: "zip包中的文件格式仅限",
      text2:
        "htm,html,js,css,jpg,jpeg,gif,png,mp3,ogg,m4a,xml,csv,dat,atf,json,plist,wav,thm,fnt,exportjson,ttf,tmx,exml,datagz,jsgz,memgz,unityweb,scml,scon,ani,atlas,lani,lh,lmat,lm,sk,ls,lav,wasm,pck,fui,ltc,prefab,part,ltcb,lamat,txt,dbbin。文件名仅限使用英文字母、英文括号、数字、下划线、减号。不符合条件的文件将被过滤掉。",
      attention: "注意:",
      text3: "1、游戏中不得自行添加广告, 不能有外链链接到其他网站",
      text4: "2、单个文件的大小限制为500M，如需上传超过500M的文件，请联系 ",
      copy: "点击复制",
      send: "提交",
      logoinfo: "请上传LOGO或主文件",
      onthecrossinfo: "上传中请耐心等待",
      save_success: "保存成功",
      onthecrosszip: "只能上传文件为zip",
      onthecrossimg: "上传LOGO只能是图片",
      onthecrosslogo: "上传LOGO图片大小不能超过 30k!",
      copysuccess: "复制成功",
      uploadimg: require("@/img/img.png"),
      upsuccess: "上传成功",
      uperror: "上传失败"
    },

    game: {
      gameinfo: "游戏信息",
      experience: "体验版",
      send: "提交时间",
      no_version: "无版本",
      gamepreview: "游戏预览",
      review_version: "审核版本",
      no_review: "无审核",
      send_review: "提交审核",
      cancel_review: "取消审核",
      text: "您还需要",
      identity: "通过身份认证",
      game_material: "提交游戏素材",
      text2: "才能提交审核",
      emailtext: "审核结果将通过邮件告知您。有疑问请联系",
      copy: "点击复制",
      online_version: "线上版本",
      publish: "发布上线",
      publish_text: "您需要通过审核才可以发布上线",
      publish_text1: "您已通过审核，可以随时上架您的游戏",
      version: "版本号",
      ok: "确认",
      cancel: "取消",
      releasesuccess: "发布成功",
      sendsuccess: "提交成功",
      no_preview: "无预览",
      copysuccess: "复制成功"
    },

    rank: {
      rank_title: "排行榜设置",
      ranklist: "排行榜列表",
      addrank: "添加排行版",
      updateRank: "修改排行版",
      no_result: "暂无数据",
      name: "排行榜名称",
      nameplaceholder: "请填写排行榜名称",
      nametext: "说明：排行榜的名称，会展示给玩家。请输入英文名称。",
      sum: "分数名称",
      sumtext:
        "说明：填写榜单的数值名称，如：关，分，级 .....。请输入英文名称。",
      sumplaceholder: "请填写分数名称",
      maxsum: "分数最大值",
      maxsumplaceholder: "请填写分数最大值",
      maxsumtext: "说明：填写排行榜分数的最大值，超过该分数不会进入排行榜。",
      radiotime: "排行榜的唯一识别ID",
      radioday: "每日",
      radioweek: "每周",
      randiomonth: "每月",
      lasting: "永久",
      radiotimetext: "会根据刷新时间间隔重置榜单数据。",
      radiotimeactive:
        "注意：保存后不可修改。若填写有误，可删除此榜单后重新添加",
      solt: "榜单顺序",
      soltplaceholder: "请填写榜单顺序",
      solttext:
        "说明：有多个榜单时，榜单在排行榜面板上显示的顺序。填写数字，数字越小表示显示越靠前。。",
      soltradio: "排序规则",
      soltradiopositive: "从小到大",
      soltradioreversed: "从大到小",
      soltradiotext:
        "从大到小：榜单分数越大的排行越靠前；从小到大：榜单分数越小的排行越靠前",
      soltradioactive: "注：保存后不可修改。若填写有误，可删除此榜单后重新添加",
      send: "保存",
      rankid: "排行榜ID",
      rankName: "排行榜名称",
      sumname: "分数名称",
      idx: "榜单顺序",
      type: "刷新时间间隔",
      action: "操作",
      alter: "修改",
      deletes: "删除",
      clearrecord: "清除记录",
      maxsumerror: "分数最大值填写不正确",
      error: "请填写完整",
      save_success: "保存成功",
      save_error: "保存失败",
      edit_success: "编辑成功",
      edit_error: "编辑失败",
      system_error: "系统错误，稍后再试",
      eliminate_success: "清除成功",
      eliminate_error: "清除失败",
      delete_success: "删除成功",
      delete_error: "删除失败",
      ok: "确认",
      cancel: "取消",
      initmodel: "是否要删除排行榜"
    }
  },
  code: {
    info: "服务器繁忙",
    "-101": "邮箱格式错误",
    "10007": "用户注册或登录失败",
    "10008": "帐号已被注册",
    "-114": "帐号被封禁",
    "1001": "验证码错误、过期或失效",
    "-103": "密码格式不正确",
    "-104": "密码长度不符合",
    "-113": "帐号密码不能为空",
    "-31": "短信发送失败",
    "-36": "验证码发送过于频繁，距离上一次发送太近",
    "-37": "验证码发送过于频繁，单位时间周期内次数过多",
    "-111": "邮箱未注册",
    "-110": "用户登录失败",
    "10014": "密码错误"
  }
};



// WEBPACK FOOTER //
// ./src/assets/common/lang/cn.js